import { salonDate } from "../../../utils/salonDate";
const parseDate = (value) => {
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(`${value}T00:00:00Z`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDate = (date) => date.toISOString().slice(0, 10);

export const buildClientAppointmentPrintRequest = (clientId, endValue = new Date(), timezone = "UTC") => {
  const end = parseDate(salonDate(endValue, timezone)) || new Date();
  const start = new Date(end.getTime());
  start.setUTCDate(start.getUTCDate() - 30);
  return {
    client_id: Number(clientId),
    start_date: formatDate(start),
    end_date: formatDate(end),
  };
};

export const getPdfDownloadDescriptor = (payload, createObjectUrl = (value) => URL.createObjectURL(value)) => {
  if (payload && typeof payload === "object" && typeof payload.html === "string") {
    return {
      href: `data:application/pdf;base64,${payload.html}`,
      revoke: false,
    };
  }
  if (typeof Blob !== "undefined" && payload instanceof Blob) {
    return { href: createObjectUrl(payload), revoke: true };
  }
  return null;
};
